import React from 'react';
import ReactDiffViewer, { DiffMethod } from 'react-diff-viewer-continued';

const ReportDiff = ({ columnName, oldReport, newReport }) => {
    const extractDisplayText = (htmlString) => {
    if (!htmlString) return '';
    
    // Use browser's native parser to clean out tags and decode entities
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, 'text/html');
    
    // Return the raw text visible to the human eye
    return doc.body.textContent || doc.body.innerText || '';
    };
    
    const oldText = extractDisplayText(oldReport) || "";
    const newText = extractDisplayText(newReport) || "";

  return (
    <div style={{ padding: '15px', border: '1px solid #dcdcdc', borderRadius: '4px' }}>
      <h4 style={{ margin: '0 0 10px 0', fontFamily: 'Arial' }}>{columnName} Changes Detail</h4>
      <ReactDiffViewer
        oldValue={oldText}
        newValue={newText}
        splitView={true} // Set to false for a single unified timeline view
        compareMethod={DiffMethod.WORDS} // Highlights exact word changes, perfect for reports
        leftTitle="Old Report"
        rightTitle="New Report"
        styles={{
          variables: {
            light: {
              diffViewerBackground: '#fff',
              addedBackground: '#e6ffed', // Light green
              addedColor: '#24292e',
              removedBackground: '#ffeef0', // Light red
              removedColor: '#24292e',
            },
          },
        }}
      />
    </div>
  );
};

export default ReportDiff;
